import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=62fdc007&scoped=true"
import script from "./LongText.vue?vue&type=script&lang=js"
export * from "./LongText.vue?vue&type=script&lang=js"
import style0 from "./LongText.vue?vue&type=style&index=0&id=62fdc007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdc007",
  null
  
)

export default component.exports